import * as React from "react";
const SvgMinusCircleFill20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
      clipRule: "evenodd"
    }),
    React.createElement("path", { fill: "#fff", d: "M5 9h10v2H5V9Z" })
  );
export default SvgMinusCircleFill20Px;
